export default __webpack_public_path__ + "static/media/thiendo1.9c5489fa.png";